export default {
    userMail: '@koromusermail.world'
}
